export default {
      id: "old-person-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#old-person",
      toString: function () {
        return this.url;
      }
    }